import { ACTIONS, KEYS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";

export interface VendorsReducer {
    vendors: any[] | null;
}

const initialState: VendorsReducer = {
    vendors: null,
};

const vendorsReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.VENDORS.SEARCH_VENDOR:
            return {
                ...state,
                vendors: action.payload,
            };

        default:
            return state;
    }
};

export default vendorsReducer;
